/* eslint-disable no-nested-ternary */
import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
// api
import {
  getInterviewStageList,
  getInterviewGroupList,
  getInterviewUserList,
  getNsUserHeaders,
} from '../../api/interviewStage';
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  stageList: [],
  stageLoading: false,
  loadGroupList: false,
  stageId: (() => {
    let id = '';
    try {
      id = JSON.parse(localStorage.getItem('stage_data'))?.id;
    } catch (err) {
      id = '';
    }
    return id;
  })(),
  currentPhase: {},
  groupList: [],
  userList: [],
  // 新生列表總數
  total: 0,
  isSingle: '',
  stageListParams: {
    offset: 0,
    limit: 10,
  },
  // 新生列表的搜索参数
  searchParams: {},
  // 是否只展示出席者
  isAttended: false,
  // 用户列表的表格头部
  NsUserHeaders: [],
  headerFilters: {},
  // 头部信息是否加载
  isLoadingHeaders: false,
};

export const getAllSearchItems = (state) => state.stage.NsUserHeaders;
export const getHeaderFilters = (state) => state.stage.headerFilters;
export const getWrappedFilters = createSelector(
  getAllSearchItems,
  getHeaderFilters,
  (items, filters) =>
    (items || []).map((item) => ({
      ...item,
      is_hidden:
        filters[item.key] === undefined
          ? item.is_hidden
          : filters[item.key]
          ? 'N'
          : 'Y',
    }))
);

const slice = createSlice({
  name: 'stage',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    startLoadGroupList(state) {
      state.loadGroupList = true;
    },
    clearLoadGroupList(state) {
      state.loadGroupList = false;
    },
    getStageListSuccess(state, action) {
      state.stageLoading = false;
      state.stageList = action.payload;
    },
    setStageLoading(state, action) {
      state.stageLoading = action.payload;
    },
    getStageId(state, action) {
      const stage = state.stageList.find(
        ($stage) => $stage?.display_id === action.payload
      );
      state.stageId = stage?.id || undefined;
      state.currentPhase = stage;
      state.isSingle = stage?.is_single;
    },
    getGroupListSuccess(state, action) {
      state.groupList = action.payload;
      state.loadGroupList = false;
    },
    getUserListSuccess(state, action) {
      state.isLoading = false;
      state.userList = action.payload?.rows || [];
      state.total = action.payload?.total || 0;
    },
    clearUserList(state) {
      state.isLoading = true;
      state.userList = [];
      state.total = 0;
    },
    updateCurUser(state, { payload }) {
      state.isLoading = false;
      state.userList = state.userList.map((item) =>
        item.ns_user_id === payload.ns_user_id ? payload : item
      );
    },
    updateCurUserScore(state, { payload }) {
      const { data } = payload;

      state.isLoading = false;
      state.userList = state.userList.map((item) =>
        item.ns_user_id === data[0].ns_user_id
          ? { ...item, total_score: data[0].total_score }
          : item
      );
    },
    setIsSingle(state, action) {
      state.isSingle = action?.payload || 'Y';
    },
    setStageListParams(state, { payload }) {
      console.log(payload);
      state.stageListParams = { ...state.stageListParams, ...payload };
    },
    setSearchParams(state, { payload }) {
      state.searchParams = { ...state.searchParams, ...payload };
    },
    setIsAttended(state, { payload }) {
      state.isAttended = payload;
    },
    getNsUserHeaders(state, { payload }) {
      state.NsUserHeaders = payload;
      state.isLoadingHeaders = false;
    },
    setHeaderFilters(state, action) {
      const headers = action.payload;
      state.headerFilters = headers;
    },
    resetHeaderFilters(state) {
      state.headerFilters = {};
    },
    loadingHeaders(state) {
      state.isLoadingHeaders = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.isLoadingHeaders = false;
      state.loadGroupList = false;
      state.error = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  getStageId,
  setIsSingle,
  setStageListParams,
  setSearchParams,
  getUserListSuccess,
  getGroupListSuccess,
  setIsAttended,
  setHeaderFilters,
  hasError: resetPhase,
  updateCurUser,
  updateCurUserScore,
  clearUserList,
  startLoadGroupList,
  clearLoadGroupList,
} = slice.actions;
// ----------------------------------------------------------------------
// 获取面試階段阶段列表
export function getStageList({ errCallBack }) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.setStageLoading(true));
      const response = await getInterviewStageList();
      const dataList = response.sort((a, b) => a.id - b.id);
      dispatch(slice.actions.getStageListSuccess(dataList));
    } catch (error) {
      // eslint-disable-next-line no-unused-expressions
      errCallBack && errCallBack();
      dispatch(slice.actions.getStageListSuccess([]));
      dispatch(slice.actions.setStageLoading(false));
    }
  };
}
// 获取面试小组列表
export function getGroupList(id) {
  return async (dispatch) => {
    try {
      const stageId =
        id || JSON.parse(localStorage.getItem('stage_data') || '')?.id;
      if (stageId) {
        const response = await getInterviewGroupList(stageId);
        const newArr = response.sort((a, b) => a.id - b.id);
        dispatch(slice.actions.getGroupListSuccess(newArr));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// 获取面试表格列表
export function getUserList(parms) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await getInterviewUserList(parms);
      console.log('response', response);
      dispatch(slice.actions.getUserListSuccess(response));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
// 得到新生列表表格头部
export function fetchNsUserHeaders(params) {
  return async (dispatch) => {
    dispatch(slice.actions.loadingHeaders());
    try {
      const response = await getNsUserHeaders(params);
      // console.log('response', response);
      dispatch(slice.actions.getNsUserHeaders(response));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
